<div fxLayout="column" fxFlexFill class="content-container" fxLayoutGap="5px">
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters, or type any text to search"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
    <app-filter-row-additional-content>
      <!--<button mat-raised-button color="primary" matTooltip="Add holiday greeting" *ngIf="hasEditAccess"
              (click)="navigateToDetails()">
        + Add
      </button>-->
    </app-filter-row-additional-content>
  </app-grid-filter>

  <div fxFlex class="stretched-container">
    <app-pbx-accounts-grid [filterChangeEvent]="filterChangeEvent"></app-pbx-accounts-grid>
  </div>
</div>
